import React from "react";
import { DollarSign, TrendingUp, Calculator } from "lucide-react";

const data = [
  { year: 2025, EBITDA: 745200, taxesCapex: 170000, FCF: 575200 },
  { year: 2026, EBITDA: 804816, taxesCapex: 185000, FCF: 619816 },
  { year: 2027, EBITDA: 869201, taxesCapex: 200000, FCF: 669201 },
  { year: 2028, EBITDA: 938737, taxesCapex: 220000, FCF: 718737 },
  { year: 2029, EBITDA: 1013836, taxesCapex: 240000, FCF: 773836 },
];

const terminalValue = (773836 * 1.03) / (0.12 - 0.03);
const enterpriseValue = 5250000;

const IncomeApproach = () => {
  return (
    <div className="p-6 bg-white shadow rounded-xl mb-6">
      <div className="flex items-center mb-4">
        <Calculator className="h-6 w-6 text-blue-500 mr-2" />
        <h3 className="text-lg font-medium text-gray-900">Income Approach (DCF Valuation)</h3>
      </div>
      <p>
        The Income Approach values the business based on its projected future cash flows discounted to present value.
      </p>
      <h3 className="text-lg font-semibold mt-4 flex items-center">
        <TrendingUp className="mr-2 text-green-500" /> DCF Assumptions
      </h3>
      <ul className="list-disc ml-5">
        <li>Revenue growth rate: 8% annually</li>
        <li>EBITDA margin: 26.5%</li>
        <li>Discount rate (WACC): 12%</li>
        <li>Terminal growth rate: 3%</li>
      </ul>
      
      <h3 className="text-lg font-semibold mt-4 flex items-center mb-4">
        <DollarSign className="mr-2 text-purple-500" /> Projected Free Cash Flows (FCF)
      </h3>
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-200">
            <th className="border border-gray-300 p-2">Year</th>
            <th className="border border-gray-300 p-2">EBITDA</th>
            <th className="border border-gray-300 p-2">Less: Taxes & Capex</th>
            <th className="border border-gray-300 p-2">FCF</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.year} className="text-center">
              <td className="border border-gray-300 p-2">{row.year}</td>
              <td className="border border-gray-300 p-2">${row.EBITDA.toLocaleString()}</td>
              <td className="border border-gray-300 p-2">${row.taxesCapex.toLocaleString()}</td>
              <td className="border border-gray-300 p-2">${row.FCF.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <h3 className="text-lg font-semibold mt-4 flex items-center mb-2">
        <Calculator className="mr-2 text-blue-500" /> Terminal Value Calculation
      </h3>
      <p>
        Using the Gordon Growth Model: TV = (Final Year FCF × (1 + Terminal Growth)) / (WACC - Terminal Growth)
      </p>
      <p><strong>Terminal Value:</strong> ${terminalValue.toLocaleString()}</p>
      
      <h3 className="text-lg font-semibold mt-4 flex items-center">
        <DollarSign className="mr-2 text-green-500" /> Enterprise Value (EV)
      </h3>
      <div className="mt-4 p-4 bg-gray-100 rounded-lg">
        <h3 className="text-lg font-semibold">Income Approach Valuation Estimate:</h3>
        <p className="text-gray-800 font-bold">
          ${enterpriseValue.toLocaleString()}
        </p>
      </div>
    </div>
  );
};

export default IncomeApproach;